
import { computed, defineComponent } from "vue";

import { CBtn, CIcon } from "../../vuetify-components";

export default defineComponent({
  components: { CBtn, CIcon },
  mixins: [CBtn],
  props: {
    href: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primary",
    },
  },
  setup(props) {
    const downloadLink = computed(() => {
      // Explicit Providid Override
      if (props.href !== "") {
        return props.href;
      }

      return "https://ltk.app.link/fLHsPHg3MR";
    });

    return {
      downloadLink,
    };
  },
});
